export const SET_PREFERENCE = 'SET_PREFERENCE';

export const RESET_PREFERENCES = 'RESET_PREFERENCES';

// Update a single user preference. Persisted client-side via redux-persist
// (the whole store is persisted — see src/store.js), so no backend is needed.
export const setPreference = (key, value) => ({
  type: SET_PREFERENCE,
  key,
  value,
});

export const resetPreferences = () => ({
  type: RESET_PREFERENCES,
});
